import { Button } from '@rhpc/ui';

interface ConfirmDialogProps {
  title: string;
  message: string;
  confirmLabel: string;
  confirmVariant?: 'default' | 'destructive';
  isLoading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({
  title,
  message,
  confirmLabel,
  confirmVariant = 'default',
  isLoading = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-6" role="dialog" aria-modal="true">
      <div className="absolute inset-0 bg-text/40" onClick={onCancel} />
      <div className="relative w-full max-w-md rounded-lg border border-border bg-surface p-6 shadow-lg">
        <h2 className="mb-2 text-h3 text-text">{title}</h2>
        <p className="mb-6 text-sm text-text-2">{message}</p>
        <div className="flex justify-end gap-2.5">
          <Button variant="secondary" onClick={onCancel} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            id="confirm-dialog-btn"
            variant={confirmVariant === 'destructive' ? 'destructive' : 'primary'}
            onClick={onConfirm}
            loading={isLoading}
          >
            {confirmLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}
